import moment from "moment";
import { convertToPercent, deepCopy, round, setUpDate } from "../../../app/util";
import { useDataSummary } from "../../Tile/kpiService";
import dataService from "../../../services/data.service";
import { useSelector } from "react-redux";

// budgetDataset carries its own Capacity/VCapacity (same shape as OTB's HotelTotal.primary
// block). Stamps vcap-aware Occ/RevPAR + _vcap popover fields onto dataObj for one budget row.
// If VCapacity is null/0, falls back to Capacity and leaves values unchanged.
const applyVCap = (dataObj, keyValue, budgetDataset, useVarCapacity) => {
    const vCap = budgetDataset?.VCapacity || budgetDataset?.Capacity;
    if (keyValue === "Occ") {
        if (useVarCapacity && vCap && budgetDataset.Rooms !== undefined) {
            dataObj[keyValue] = convertToPercent(budgetDataset.Rooms / vCap);
        } else {
            dataObj[keyValue] = budgetDataset['Occ%'];
        }
        if (vCap) {
            dataObj._vcap = useVarCapacity ? vCap : budgetDataset.Capacity;
            dataObj._vcapLabel = (useVarCapacity && budgetDataset.VCapacity) ? 'Variable Capacity' : 'Capacity';
            dataObj._vcapDiffers = !!(budgetDataset.VCapacity && budgetDataset.VCapacity !== budgetDataset.Capacity);
        }
    } else if (keyValue === "RevPAR") {
        if (useVarCapacity && vCap && budgetDataset.Revenue !== undefined) {
            dataObj[keyValue] = budgetDataset.Revenue / vCap;
        } else {
            dataObj[keyValue] = budgetDataset[keyValue];
        }
    } else {
        dataObj[keyValue] = budgetDataset[keyValue];
    }
};

export function getBudgetData(data, columns, app_state, ui_state = {}) {
    let dataKey = "HotelTotal";
    let setup_data = [];
    const useVarCapacity = !!(ui_state?.showVariableCapacity);
    // data = data.filter((itm) => moment(itm.date).format('YYYY-MM-01') >= moment().format('YYYY-MM-01'))
    data.map((item, index) => {

        // if (moment(item.date).format('MMM, YYYY') >= moment().format('MMM, YYYY')) {
            let data_columns = [];
            columns.map(col => {
                let dataObj = { id: col.id };
                if (col.type === 'dateColumn') {
                    dataObj = setUpDate(dataObj, item.index.date);
                }
                if (col.type === 'dataColumn') {
                    col.subcolumns.map(key => {
                        applyVCap(dataObj, key.value, item.budgetDataset, useVarCapacity);
                    })
                }
                data_columns.push(dataObj);
            })
            setup_data.push(data_columns);
        // }
    })
    return setup_data;
}


// function to get Budget data
export const getBudgetInt = (date,mainKey, id, tileName, k, key, index, dataKey, auth, app_state, ui_state = {}) => {
     let budgetData = (dataService.getSeriesById("GetBudget").data)?deepCopy(dataService.getSeriesById("GetBudget").data.data):[];
    let dataObj = {};
    let keyValue = key.value;
    const useVarCapacity = !!(ui_state?.showVariableCapacity);
    if(tileName === "budget" && budgetData){
        let itemsArr = budgetData.filter((item)=> item.index.date === moment(date).format('YYYY-MM-DD'));
        if(itemsArr && itemsArr.length){
            applyVCap(dataObj, keyValue, itemsArr[0].budgetDataset, useVarCapacity);
        }else{
            dataObj[keyValue] = 0;
        }
    }
    return dataObj;
}


